import React from 'react';
import { systemConfig } from '../config';

export const HtmlHead = () => (
  <>
    <meta charset="utf-8" />
    <link rel="icon" href={`%PUBLIC_URL%${systemConfig.logos.favicon}`} />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content={systemConfig.theme.primaryColor} />
    <meta name="description" content={systemConfig.description} />
    <link rel="apple-touch-icon" href={`%PUBLIC_URL%${systemConfig.logos.pwa.small}`} />
    <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
    <title>{systemConfig.name}</title>
  </>
);
